export const initialValue = [
    { type: "h1", children: [{ text: "Enter text..." }] }
];
